import styled from "styled-components";

export const AppContainer = styled.div`
    color: white;
    display: grid;
    background-color: ${props => props.theme.palette.common.gray['100']};

    & a {
        color: ${props => props.theme.palette.common.black};
    }

    & a:hover {
        color: ${props => props.theme.palette.primary.darkest};
    }
`;